import __request__ from "routing/request";
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/roles", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listAll(requestOptions) {
  return __request__("GET", "/roles", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(rolename, JSONbody, requestOptions) {
  return __request__("PUT", `/roles/${rolename}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function read(rolename, requestOptions) {
  return __request__("GET", `/roles/${rolename}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(rolename, requestOptions) {
  return __request__("DELETE", `/roles/${rolename}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getMembers(rolename, requestOptions) {
  return __request__("GET", `/roles/${rolename}/members`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeMember(rolename, username, requestOptions) {
  return __request__("DELETE", `/roles/${rolename}/members/${username}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addMember(JSONbody, rolename, username, requestOptions) {
  return __request__("PUT", `/roles/${rolename}/members/${username}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
